import { render, staticRenderFns } from "./ApplicantDeposits.vue?vue&type=template&id=3b18198c&scoped=true&"
import script from "./ApplicantDeposits.vue?vue&type=script&lang=js&"
export * from "./ApplicantDeposits.vue?vue&type=script&lang=js&"
import style0 from "./ApplicantDeposits.vue?vue&type=style&index=0&id=3b18198c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b18198c",
  null
  
)

export default component.exports